import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getLinks } from "../api";
import { linksKeys } from "./keys";

// Affiliate links list — server-paginated and searchable.
export const useLinksQuery = (params) =>
  useQuery({
    queryKey: linksKeys.list(params),
    queryFn: async () => {
      const { data } = await getLinks(params.page, params.size, params.search);
      return data;
    },
    enabled: !!params,
    ...reactQueryCacheAndRefetchOptions,
  });
